import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components/macro";

import { mediaQueries } from "../styles/media.js";
import Center from "./Center";
import Header from "./Header";
import Footer from "./Footer";

const MainContent = styled.main`
  display: block;

  ${mediaQueries.md} {
    padding-bottom: var(--juno-image-space-md);
    padding-top: ${(props) => (props.pageWidth === "narrow" ? "40px" : "30px")};
  }

  background-color: ${(props) => (props.pageWidth === "narrow" ? "transparent" : "var(--juno-color-off-white)")};
  ${(props) => (props.background === "white" ? "background-color: var(--juno-color-white);" : null)}
`;

const MainContentInner = styled(Center)`
  position: relative;
  background: var(--juno-page-content-background-sm);
  ${(props) => (props.pageWidth === "narrow" ? "background: transparent;" : null)}
  padding-inline-start: 0;
  padding-inline-end: 0;

  ${mediaQueries.md} {
    background: transparent;
    padding-inline-start: var(--juno-space-12);
    padding-inline-end: var(--juno-space-12);
  }
`;

class PageLayout extends Component {
  render() {
    return (
      <>
        <Header pageWidth={this.props.pageWidth} showLogout={this.props.showLogout} />
        <MainContent pageWidth={this.props.pageWidth} background={this.props.background}>
          <MainContentInner pageWidth={this.props.pageWidth}>{this.props.children}</MainContentInner>
        </MainContent>
        <Footer pageWidth={this.props.pageWidth} reversed />
      </>
    );
  }
}

export default PageLayout;

PageLayout.propTypes = {
  pageWidth: PropTypes.oneOf(["narrow", "regular", "wide", "wider", "widest"]),
  showLogout: PropTypes.bool,
};

PageLayout.defaultProps = {
  pageWidth: "regular",
  showLogout: false,
};
